// Coded blog articles: reading progress bar + active contents link.
// Progressive enhancement only: the contents list, anchors and FAQ all work
// without this file. Vanilla, no dependencies.
(function () {
  var root = document.querySelector('.blog-article');
  if (!root) return;
  var bar = root.querySelector('#blog-progress');
  var links = [].slice.call(root.querySelectorAll('.blog-rail [data-blog-toc]'));
  var targets = links.map(function (a) { return document.getElementById(a.getAttribute('data-blog-toc')); });
  var ticking = false;

  function update() {
    ticking = false;
    var d = document.documentElement;
    var max = d.scrollHeight - d.clientHeight;
    if (bar) bar.style.width = (max > 0 ? Math.min(100, (d.scrollTop || window.pageYOffset) / max * 100) : 0) + '%';
    var active = -1;
    for (var i = 0; i < targets.length; i++) {
      if (targets[i] && targets[i].getBoundingClientRect().top < 140) active = i;
    }
    // at the very bottom the last heading wins even if it never reaches the line
    if (max > 0 && d.scrollTop >= max - 4 && targets.length) active = targets.length - 1;
    links.forEach(function (a, i) { a.classList.toggle('is-active', i === (active < 0 ? 0 : active)); });
  }

  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();

// Swipe rows (media galleries, related posts) get an obvious control bar on
// phones: a "Swipe" hint, prev/next buttons, a counter and dots. The rows
// still scroll natively without it. CSS hides the bar at tablet+ widths.
(function () {
  var root = document.querySelector('.blog-article');
  if (!root) return;
  [].slice.call(root.querySelectorAll('[data-blog-gallery], .blog-related__grid')).forEach(function (row) {
    var items = [].slice.call(row.children);
    if (items.length < 2) return;
    var bar = document.createElement('div');
    bar.className = 'blog-swipe';
    bar.innerHTML = '<span class="blog-swipe__hint" aria-hidden="true">Swipe <i>&rarr;</i></span>' +
      '<span class="blog-swipe__dots" aria-hidden="true">' + items.map(function () { return '<b></b>'; }).join('') + '</span>' +
      '<span class="blog-swipe__count" aria-live="polite"></span>' +
      '<button type="button" class="blog-swipe__btn" data-dir="-1" aria-label="Previous">&lsaquo;</button>' +
      '<button type="button" class="blog-swipe__btn" data-dir="1" aria-label="Next">&rsaquo;</button>';
    row.parentNode.insertBefore(bar, row.nextSibling);
    var dots = [].slice.call(bar.querySelectorAll('.blog-swipe__dots b'));
    var count = bar.querySelector('.blog-swipe__count');
    var prev = bar.querySelector('[data-dir="-1"]');
    var next = bar.querySelector('[data-dir="1"]');
    var moved = false, base = row.scrollLeft;

    function current() {
      var x = row.scrollLeft - base + 8, idx = 0;
      items.forEach(function (it, i) { if (it.offsetLeft - items[0].offsetLeft <= x) idx = i; });
      if (row.scrollLeft + row.clientWidth >= row.scrollWidth - 4 && row.scrollLeft > base) idx = items.length - 1;
      return idx;
    }
    function sync() {
      var i = current();
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      count.textContent = (i + 1) + ' / ' + items.length;
      prev.disabled = i === 0;
      next.disabled = i === items.length - 1;
      if (Math.abs(row.scrollLeft - base) > 24 && !moved) { moved = true; bar.classList.add('is-moved'); }
    }
    function go(dir) {
      var i = Math.max(0, Math.min(items.length - 1, current() + dir));
      row.scrollTo({ left: base + items[i].offsetLeft - items[0].offsetLeft, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    row.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
})();
